module.exports = __webpack_public_path__ + "img/八角茴香.cd9c8dd3.jpg";